import { render, staticRenderFns } from "./ScreenInformacion.vue?vue&type=template&id=6a74ce9c"
import script from "./ScreenInformacion.vue?vue&type=script&lang=js"
export * from "./ScreenInformacion.vue?vue&type=script&lang=js"
import style0 from "./ScreenInformacion.vue?vue&type=style&index=0&id=6a74ce9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports